
import File, {BaseItem} from "../../file/File";

export function getItems(files: File[]): BaseItem[] {
  return files.reduce<BaseItem[]>((acc, cur) => [...acc, ...(cur?.content?.items ?? [])], []);
}

export default getItems;
